<main class="dialog-body">
    <div class="dialog-header">
        <div class="dialog-header-text">{{ isEdit ? 'Edit school details' : 'Add school details' }}</div>
        <div class="cross-icon" (click)="onCancel()">
            <img src="assets/images/cross-icon.svg" class="cross-icon-img" />
        </div>
    </div>

    <mat-dialog-content class="dialog-content">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="d-grid gap-14">
            <div class="grid-container">
                <div class="form-group">
                    <app-input context="Normal" label="School name" placeholder="Enter your school name" type="text"
                        [control]="form.get('schoolName')" [required]="true"
                        [customErrorMessages]="{ required: 'Please enter a school name.' }">
                    </app-input>
                </div>

                <div class="form-group">
                    <app-input context="Normal" label="School type" placeholder="Select school type" type="select"
                        [control]="form.get('schoolType')" [options]="schoolTypeOptions" [required]="true"
                        [customErrorMessages]="{ required: 'Please select a school type.' }">
                    </app-input>
                </div>
            </div>

            <div class="form-group">
                <app-input context="Normal" label="Address" placeholder="Enter your address" type="text"
                    [required]="true" [control]="form.get('address')"
                    [customErrorMessages]="{ required: 'Please enter a address.' }">
                </app-input>
            </div>

            <div class="grid-container">
                <div class="form-group">
                    <app-input context="Normal" label="Suburb" placeholder="Enter your suburb" type="text"
                        [required]="true" [control]="form.get('suburb')"
                        [customErrorMessages]="{ required: 'Please enter a suburb.' }">
                    </app-input>
                </div>
                <div class="form-group">
                    <app-input context="Normal" label="Postcode" placeholder="Enter your postcode" type="text"
                        [control]="form.get('postcode')" [required]="true"
                        [customErrorMessages]="customErrorMessages.postcode">
                    </app-input>
                </div>
            </div>

            <div class="grid-container">
                <div class="form-group">
                    <app-input context="Normal" label="Region" placeholder="Select region" type="select"
                        [control]="form.get('region')" [options]="regionOptions" [required]="true"
                        [customErrorMessages]="{ required: 'Please enter a region.' }">
                    </app-input>
                </div>
                <div class="form-group">
                    <app-input context="Normal" label="State" placeholder="Queensland(QLD)" type="text"
                        [control]="form.get('state')" [disabled]="true">
                    </app-input>
                </div>
            </div>

            <div class="radio-container">
                <label class="radio-text">
                    <input type="radio" formControlName="schoolCategory" value="mou" class="radio-input" />
                    <span class="radio-checkmark"></span>
                    <span class="radio-label">Partnership School/s</span>
                </label>
                <label class="radio-text">
                    <input type="radio" formControlName="schoolCategory" value="nonMou" class="radio-input" />
                    <span class="radio-checkmark"></span>
                    <span class="radio-label">Non-Partnership School/s</span>
                </label>
            </div>

            <div class="d-grid gap-14">
                <div class="checkbox-container" *ngIf="!isEdit && form.get('schoolCategory')?.value">
                    <label class="checkbox-wrapper">
                        <input type="checkbox" class="checkbox-input" formControlName="showContacts"
                            (change)="onContactsCheckboxChange()" />
                        <span class="checkbox-checkmark"></span>
                        <span class="checkbox-label">Contact details</span>
                    </label>
                </div>

                <div *ngIf="!isEdit && form.get('showContacts')?.value">
                    <div *ngIf="form.get('showContacts')?.value">
                        <div class="contacts-section d-grid gap-14 ">

                            <div class="section-header d-flex justify-content-between align-items-center"
                                [ngClass]="{ 'd-none': contactsArray.length === 0 }">
                                <h4 class="section-title">
                                    Added contacts ({{ contactsArray.length }})
                                </h4>
                            </div>

                            <div formArrayName="contacts" [ngClass]="{ 'd-none': contactsArray.length === 0 }">
                                <div class="existing-contacts" *ngIf="contactsArray.length > 0">
                                    <div class="contacts-list">
                                        <div *ngFor="let contact of contactsArray.controls; let i = index"
                                            [formGroupName]="i" class="contact-item">
                                            <div class="contact-details">
                                                <div class="contact-field">
                                                    <div>Name :</div>
                                                    <span>{{ contact.get('name')?.value }}</span>
                                                </div>
                                                <div class="contact-field">
                                                    <div>Phone :</div>
                                                    <span>{{ contact.get('phone')?.value }}</span>
                                                </div>
                                                <div class="contact-field">
                                                    <div>Email : <span>{{ contact.get('email')?.value }}</span></div>
                                                    <!-- <span>{{ contact.get('email')?.value }}</span> -->
                                                </div>
                                                <div class="contact-field">
                                                    <div>Position :</div>
                                                    <span>{{ contact.get('position')?.value }}</span>
                                                </div>
                                            </div>
                                            <div class="contact-actions">
                                                <button class="edit-btn" (click)="editContact(i)">
                                                    <img src="assets/images/Buttons/edit-button.svg" alt="Edit" />
                                                </button>
                                                <button class="delete-btn" (click)="deleteContact(i)">
                                                    <img src="assets/images/Buttons/delete-button.svg" alt="Delete" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="new-contact-form d-grid gap-14" *ngIf="showNewContactForm">
                                <div class="grid-container">
                                    <div class="form-group">
                                        <app-input context="Normal" label="Contact name" [required]="true"
                                            placeholder="Enter your contact name" type="text"
                                            [control]="newContactForm.get('name')"
                                            [customErrorMessages]="{ required: 'Please enter a contact name.' }">
                                        </app-input>
                                    </div>
                                    <div class="form-group">
                                        <app-input context="Normal" label="Phone number" [required]="true"
                                            placeholder="Enter your phone number" type="tel"
                                            [control]="newContactForm.get('phone')" [customErrorMessages]="{
                required: 'Please enter a phone number.',
                pattern: 'Please enter a valid phone number.'
            }">
                                        </app-input>
                                    </div>
                                </div>
                                <div class="grid-container">
                                    <div class="form-group">
                                        <app-input context="Normal" label="Email" placeholder="Enter your email"
                                            [required]="true" type="email" [control]="newContactForm.get('email')"
                                            [customErrorMessages]="{ required: 'Please enter a email address.', email: 'Please enter a valid email address.' }">
                                        </app-input>
                                    </div>
                                    <div class="form-group">
                                        <app-input context="Normal" label="Position" placeholder="Enter your position"
                                            type="text" [control]="newContactForm.get('position')" [required]="true"
                                            [customErrorMessages]="{ required: 'Please enter a position.' }">
                                        </app-input>
                                    </div>
                                </div>
                                <div class="addContent">
                                    <button class="add-cancel-btn" type="button" (click)="cancelContact()">
                                        Cancel
                                    </button>
                                    <button class="add-contact-btn" (click)="addContact()"
                                        [disabled]="!newContactForm.valid || isProcessing"
                                        [class.disabled]="!newContactForm.valid || isProcessing">
                                        Add contact
                                    </button>
                                </div>
                            </div>

                            <div class="addMore" *ngIf="!showNewContactForm && contactsArray.length > 0">
                                <button class="add-more-btn" (click)="showNewContactForm = true">
                                    + Add more
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="checkbox-container mt-2" *ngIf="!isEdit && form.get('schoolCategory')?.value">
                <label class="checkbox-wrapper">
                    <input type="checkbox" class="checkbox-input" formControlName="showTeachers"
                        (change)="onTeachersCheckboxChange()" />
                    <span class="checkbox-checkmark"></span>
                    <span class="checkbox-label">Teacher details</span>
                </label>
            </div>

            <div *ngIf="form.get('showTeachers')?.value">
                <div class="teachers-section">

                    <div class="section-header d-flex justify-content-between align-items-center"
                        [ngClass]="{ 'd-none': teachersArray.length === 0 }">
                        <h4 class="section-title" *ngIf="teachersArray.length > 0">
                            Added Teachers ({{ teachersArray.length }})
                        </h4>
                    </div>

                    <div formArrayName="teachers" [ngClass]="{ 'd-none': teachersArray.length === 0 }">
                        <div class="existing-teachers" *ngIf="teachersArray.length > 0">
                            <div class="teachers-list">
                                <div *ngFor="let teacher of teachersArray.controls; let i = index" [formGroupName]="i"
                                    class="teacher-item">
                                    <div class="teacher-details">
                                        <div class="teacher-field">
                                            <div>Name :</div>
                                            <span>{{ teacher.get('firstName')?.value }} {{
                                                teacher.get('lastName')?.value }}</span>
                                        </div>
                                        <div class="teacher-field">
                                            <div>Phone :</div>
                                            <span>{{ teacher.get('phone')?.value }}</span>
                                        </div>
                                        <div class="teacher-field">
                                            <div>Email : <span>{{ teacher.get('email')?.value }}</span></div>
                                            <!-- <span>{{ teacher.get('email')?.value }}</span> -->
                                        </div>
                                    </div>
                                    <div class="teacher-actions">
                                        <button class="edit-btn" (click)="editTeacher(i)">
                                            <img src="assets/images/Buttons/edit-button.svg" alt="Edit" />
                                        </button>
                                        <button class="delete-btn" (click)="deleteTeacher(i)">
                                            <img src="assets/images/Buttons/delete-button.svg" alt="Delete" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="new-teacher-form d-grid gap-14" *ngIf="showNewTeacherForm">
                        <div class="grid-container">
                            <div class="form-group">
                                <app-input context="Normal" label="First name" placeholder="Enter your first name"
                                    type="text" [control]="newTeacherForm.get('firstName')" [required]="true"
                                    [customErrorMessages]="{ required: 'Please enter a first name.' }">
                                </app-input>
                            </div>
                            <div class="form-group">
                                <app-input context="Normal" label="Last name" placeholder="Enter your last name"
                                    type="text" [control]="newTeacherForm.get('lastName')" [required]="true"
                                    [customErrorMessages]="{ required: 'Please enter a last name.' }">
                                </app-input>
                            </div>
                        </div>
                        <div class="grid-container">
                            <div class="form-group">
                                <app-input context="Normal" label="Email" placeholder="Enter your email" type="email"
                                    [control]="newTeacherForm.get('email')" [required]="true"
                                    [customErrorMessages]="{ required: 'Please enter a email address.', email: 'Please enter a valid email address.' }">
                                </app-input>
                            </div>
                            <div class="form-group">
                                <app-input context="Normal" label="Phone" placeholder="Enter your phone number"
                                    [required]="false" type="tel" [control]="newTeacherForm.get('phone')"
                                    [customErrorMessages]="{
            pattern: 'Please enter a valid phone number.'
        }">
                                </app-input>
                            </div>
                        </div>
                        <div class="addContent">
                            <button class="add-cancel-btn" type="button" (click)="cancelTeacher()">
                                Cancel
                            </button>
                            <button class="add-teacher-btn" (click)="addTeacher()"
                                [disabled]="!newTeacherForm.valid || isProcessing"
                                [class.disabled]="!newTeacherForm.valid || isProcessing">
                                Add teacher
                            </button>
                        </div>
                    </div>

                    <div class="addMore" *ngIf="!showNewTeacherForm && teachersArray.length > 0">
                        <button class="add-more-btn" (click)="showNewTeacherForm = true">
                            + Add more
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions class="action-buttons">
        <button class="dialog-button cancel-button" (click)="onCancel()">
            Cancel
        </button>

        <button class="dialog-button update-button" [disabled]="isDisabled" (click)="onSubmit()">
            <span *ngIf="!isProcessing">{{ isEdit ? 'Update' : 'Submit' }}</span>
            <span *ngIf="isProcessing" class="submit-loading">
                <span class="spinner"></span>
                Submiting...
            </span>
        </button>

    </mat-dialog-actions>
</main>